// extracted by mini-css-extract-plugin
export default {"yivi-web-form":"yivi_app_bar_yivi-web-form__fUEKI","yivi-web-content":"yivi_app_bar_yivi-web-content__CTwMj","bar":"yivi_app_bar_bar__qioiC","content":"yivi_app_bar_content__MWwH5"};